import { Component, Input } from '@angular/core';
import { NewsUpdateCard } from 'src/app/model/card/news-update-card';

@Component({
  selector: 'app-news-update-card',
  templateUrl: './news-update-card.component.html',
  styleUrls: ['./news-update-card.component.scss']
})
export class NewsUpdateCardComponent {
  @Input() newsUpdateCards: NewsUpdateCard[] = [];
  @Input() newsYears: string[] = [];
  @Input() selectedYearIndex: number = 0;

  constructor() {}

  openNewsTabContentForNewsYear(newsYear: string): NewsUpdateCard[] {
    return this.newsUpdateCards.filter((newsUpdatesCard) => newsUpdatesCard.headText === newsYear).sort((a, b) => a.order - b.order);
  }
}
